import { render, staticRenderFns } from "./kpiCard.vue?vue&type=template&id=5ce6b54a&scoped=true"
import script from "./kpiCard.vue?vue&type=script&lang=js"
export * from "./kpiCard.vue?vue&type=script&lang=js"
import style0 from "./kpiCard.vue?vue&type=style&index=0&id=5ce6b54a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce6b54a",
  null
  
)

export default component.exports